export const news = [
  {
    id: 'n-1001',
    title: '年度华语科幻巨制定档暑期，主创阵容首度公开',
    summary: '片方正式宣布这部筹备三年的科幻电影将于暑期档上映，导演携主演团队亮相发布会，分享幕后拍摄故事。',
    content: [
      '经过长达三年的筹备与拍摄，年度最受期待的华语科幻电影终于官宣定档。片方在发布会上首次公开了完整主创阵容，导演与多位主演悉数到场，与媒体分享了这部作品从概念设计到实景搭建的完整历程。',
      '据介绍，影片在视觉特效上投入了超过两千个镜头，其中大部分由国内团队独立完成。美术团队搭建了占地近万平方米的实景摄影棚，力求在宏大世界观与细腻情感之间取得平衡。',
      '导演在采访中表示，科幻不只是关于未来的想象，更是关于当下人们情感与选择的投射。影片希望用类型化的外壳，讲述一个能够被普通观众共情的故事。',
      '目前影片已进入最后的调色与混音阶段，宣传物料将陆续释出。业内普遍看好其成为今年暑期档的票房主力之一。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20sci-fi%20cinema%20poster%20scene%20with%20glowing%20neon%20lights%2C%20deep%20red%20and%20orange%20color%20grading%2C%20dramatic%20spotlight%20beams%2C%20futuristic%20atmosphere%2C%20high%20contrast%20editorial%20visual%2C%20clean%20dark%20background%20for%20text&width=800&height=500&seq=news-sci-fi-01&orientation=landscape',
    category: 'film',
    categoryName: '影视新闻',
    tags: ['暑期档', '科幻电影', '定档'],
    author: '娱乐编辑部',
    source: '91.con 影视组',
    date: '2026-10-14',
    views: 128400,
    featured: true,
    hot: true,
  },
  {
    id: 'n-1002',
    title: '现象级综艺回归第二季，全新赛制引发热议',
    summary: '备受关注的综艺节目宣布第二季回归，节目组公布的全新赛制在社交平台引发广泛讨论，相关话题迅速登上热搜。',
    content: [
      '凭借第一季的口碑积累，这档现象级综艺正式官宣第二季回归。节目组在预告中释放了全新的赛制信息，打破了以往的单线竞演模式。',
      '据了解，第二季将引入跨队合作与即时淘汰相结合的机制，参赛嘉宾需要在有限的准备时间内完成舞台呈现，对综合能力提出了更高要求。',
      '消息发布后，相关话题在短时间内冲上热搜榜前列。不少观众表示期待看到更加真实的舞台竞争，也有观众对赛制的公平性提出了讨论。',
      '节目预计将于下月开启录制，正式播出时间尚未完全确定。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20television%20studio%20stage%20design%20with%20warm%20orange%20stage%20lighting%2C%20geometric%20LED%20screens%2C%20modern%20entertainment%20show%20atmosphere%2C%20rich%20red%20accents%2C%20clean%20composition%20with%20negative%20space&width=800&height=500&seq=news-variety-02&orientation=landscape',
    category: 'variety',
    categoryName: '综艺资讯',
    tags: ['综艺', '热搜', '赛制'],
    author: '综艺观察',
    source: '91.con 综艺组',
    date: '2026-10-13',
    views: 96520,
    featured: true,
    hot: true,
  },
  {
    id: 'n-1003',
    title: '年度音乐盛典阵容公布，多组实力唱将同台',
    summary: '主办方公布了本届音乐盛典的完整表演阵容，涵盖流行、说唱、独立音乐等多个领域，现场将采用全新环形舞台。',
    content: [
      '年度音乐盛典公布完整表演阵容，本届盛典邀请了来自流行、说唱、独立音乐等多个领域的歌手同台献艺。',
      '舞台设计方面，主办方透露将首次采用环形主舞台，配合沉浸式灯光与环绕音响系统，为现场观众带来更立体的听觉体验。',
      '除了演出环节，盛典还将颁发年度歌手、年度专辑等多个奖项，评选结果由专业评审与观众投票共同决定。',
      '目前门票预约已经开启，主办方提醒观众通过官方渠道获取相关信息。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20concert%20stage%20with%20warm%20orange%20and%20red%20stage%20lights%2C%20glowing%20sound%20wave%20patterns%2C%20crowd%20silhouettes%20in%20the%20distance%2C%20energetic%20music%20festival%20atmosphere%2C%20cinematic%20color%20grading&width=800&height=500&seq=news-music-03&orientation=landscape',
    category: 'music',
    categoryName: '音乐资讯',
    tags: ['音乐盛典', '舞台', '阵容'],
    author: '音乐前线',
    source: '91.con 音乐组',
    date: '2026-10-12',
    views: 74210,
    featured: true,
  },
  {
    id: 'n-1004',
    title: '实力派演员新剧杀青，挑战高难度角色引发期待',
    summary: '该剧历经四个月拍摄正式杀青，主演在社交平台分享了拍摄感悟，角色的复杂层次成为观众讨论焦点。',
    content: [
      '一部聚焦现实题材的新剧正式宣布杀青，剧组公开了主演在片场的花絮照片，引发粉丝热烈讨论。',
      '主演在社交平台上分享了四个月的拍摄感悟，坦言这次的角色在心理层面上有着很大的挑战，需要在克制与爆发之间反复调整。',
      '编剧团队表示，剧本在经过多轮打磨后才最终定稿，希望用细腻的人物刻画呈现普通人的真实生活状态。',
      '该剧目前进入后期制作阶段，预计将在明年与观众见面。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20film%20set%20backdrop%20with%20soft%20studio%20lighting%2C%20blurred%20wooden%20and%20red%20tones%2C%20moody%20cinematic%20atmosphere%2C%20clean%20minimal%20background%20suitable%20for%20news%20cover%2C%20elegant%20composition&width=800&height=500&seq=news-actor-04&orientation=landscape',
    category: 'star',
    categoryName: '明星动态',
    tags: ['新剧', '杀青', '现实题材'],
    author: '影视观察',
    source: '91.con 影视组',
    date: '2026-10-11',
    views: 63800,
    hot: true,
  },
  {
    id: 'n-1005',
    title: '脱口秀行业迎来新一季，线下剧场演出持续升温',
    summary: '随着多档脱口秀节目陆续开播，线下剧场的演出场次明显增加，年轻观众成为消费主力。',
    content: [
      '进入下半年，脱口秀行业热度持续走高。多档线上节目陆续开播的同时，各地线下剧场的演出场次也在明显增加。',
      '从业者表示，观众对真实、有共鸣的段子需求越来越强，创作者开始更加关注生活中的细节与情绪表达。',
      '不少剧场表示，周末场次往往提前售罄，年轻观众成为线下演出的主力消费群体，带动了周边餐饮与商圈的人气。',
      '业内人士认为，行业正在从流量驱动逐步回归内容本身，长期来看有助于生态的良性发展。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20warm%20abstract%20comedy%20club%20stage%20with%20a%20single%20microphone%20silhouette%2C%20amber%20and%20red%20mood%20lighting%2C%20deep%20shadows%2C%20intimate%20performance%20atmosphere%2C%20minimal%20elegant%20visual&width=800&height=500&seq=news-comedy-05&orientation=landscape',
    category: 'variety',
    categoryName: '综艺资讯',
    tags: ['脱口秀', '线下演出', '行业'],
    author: '综艺观察',
    source: '91.con 综艺组',
    date: '2026-10-10',
    views: 51870,
  },
  {
    id: 'n-1006',
    title: '备受争议的悬疑剧收官，开放式结局引爆讨论',
    summary: '该剧以开放式的结局收官，观众对剧情的多种解读在社交平台持续发酵，主创回应了创作初衷。',
    content: [
      '近期热度居高不下的悬疑剧迎来收官，开放式的结尾让观众产生了截然不同的解读，相关讨论持续升温。',
      '导演在采访中回应称，团队并不希望给出一个太过明确的答案，而是希望观众能带着自己的理解走出故事，让思考延续下去。',
      '有观众认为这样的处理给了角色更多解读空间，也有观众表示希望看到更完整的交代。',
      '无论如何，这部剧在叙事结构与表演层面都为同类型作品提供了新的参考。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Moody%20abstract%20suspense%20drama%20visual%20with%20fog%20and%20a%20single%20warm%20red%20light%20source%2C%20dark%20cinematic%20tones%2C%20mysterious%20atmosphere%2C%20grained%20texture%2C%20minimal%20editorial%20cover%20composition&width=800&height=500&seq=news-suspense-06&orientation=landscape',
    category: 'film',
    categoryName: '影视新闻',
    tags: ['悬疑剧', '收官', '结局'],
    author: '影视观察',
    source: '91.con 影视组',
    date: '2026-10-09',
    views: 88340,
    hot: true,
  },
  {
    id: 'n-1007',
    title: '新生代歌手发布首张个人专辑，曲风多元获好评',
    summary: '这位新生代歌手带着首张个人专辑正式亮相，专辑横跨流行、R&B 与民谣风格，获得乐评人正面评价。',
    content: [
      '新生代歌手正式发行了个人首张专辑，专辑收录多首风格各异的作品，展现了她对多元曲风的驾驭能力。',
      '专辑制作历时一年多，邀请了多位音乐人参与编曲与制作。歌手表示，希望每一首歌都能讲述一段真实的情绪。',
      '多位乐评人对专辑的整体完成度给出了正面评价，认为其在制作与表达之间找到了不错的平衡。',
      '后续她计划开启小型巡演，与歌迷进行更近距离的交流。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20music%20album%20visual%20with%20vinyl%20record%20and%20soft%20orange%20gradient%20light%2C%20delicate%20sound%20wave%20overlay%2C%20modern%20elegant%20aesthetic%2C%20clean%20dark%20background%20for%20text&width=800&height=500&seq=news-album-07&orientation=landscape',
    category: 'music',
    categoryName: '音乐资讯',
    tags: ['新专辑', '新生代', '巡演'],
    author: '音乐前线',
    source: '91.con 音乐组',
    date: '2026-10-08',
    views: 43720,
  },
  {
    id: 'n-1008',
    title: '多位导演宣布合作计划，现实题材成为行业共识',
    summary: '在近期的一场行业论坛上，多位导演分享了各自的创作计划，现实题材与人文关怀成为共同的关注方向。',
    content: [
      '在一场面向行业与观众的创作论坛上，多位导演分享了各自的下一阶段计划，现实题材成为被反复提及的关键词。',
      '有导演提到，观众的审美正在快速成长，创作者需要用更真诚的态度去观察生活，而不是简单地追逐热点。',
      '也有创作者谈到，技术手段的进步为叙事提供了更多可能，但故事的内核始终是人物与情感。',
      '与会者普遍认为，行业的长期发展离不开对内容质量的坚持。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20creative%20industry%20forum%20scene%20with%20warm%20amber%20lighting%2C%20blurred%20stage%20and%20screen%2C%20professional%20yet%20artistic%20atmosphere%2C%20red%20accent%20tones%2C%20clean%20composition&width=800&height=500&seq=news-forum-08&orientation=landscape',
    category: 'film',
    categoryName: '影视新闻',
    tags: ['行业论坛', '现实题材', '创作'],
    author: '娱乐编辑部',
    source: '91.con 影视组',
    date: '2026-10-07',
    views: 31250,
  },
  {
    id: 'n-1009',
    title: '热门剧集海外发行，文化内容走向更广市场',
    summary: '多部国产剧集宣布将在海外多个平台上线，业内人士认为这有助于提升华语内容的国际影响力。',
    content: [
      '多部国产剧集近日宣布将在海外主流平台上线，覆盖多个国家和地区的观众。',
      '相关负责人表示，团队在字幕与配音上进行了本地化适配，努力让不同文化背景的观众都能理解剧情。',
      '业内分析认为，华语内容出海不仅带来了商业价值，也为文化交流提供了新的窗口。',
      '未来一段时间，还会有更多作品陆续公布海外发行计划。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20global%20map%20made%20of%20warm%20glowing%20dots%20and%20lines%2C%20cinematic%20dark%20backdrop%20with%20red%20and%20orange%20accents%2C%20modern%20editorial%20visual%20suggesting%20content%20going%20global%2C%20clean%20composition&width=800&height=500&seq=news-global-09&orientation=landscape',
    category: 'film',
    categoryName: '影视新闻',
    tags: ['海外发行', '文化输出', '剧集'],
    author: '娱乐编辑部',
    source: '91.con 影视组',
    date: '2026-10-06',
    views: 28940,
  },
  {
    id: 'n-1010',
    title: '舞台剧跨界改编电影，主创谈两种媒介的碰撞',
    summary: '一部口碑舞台剧将迎来电影版改编，主创团队分享了在保留舞台张力与适配银幕表达之间的取舍。',
    content: [
      '一部口碑舞台剧宣布将改编为电影版本，消息公布后引发了戏剧与电影观众的共同关注。',
      '主创团队表示，舞台的现场感与电影的镜头语言各有优势，改编过程更像是一次再创作，而不是简单的搬演。',
      '在保留原作情感内核的同时，电影版会通过镜头调度与空间设计，带给观众不同的观看体验。',
      '影片计划于明年开机，具体阵容将在后续公布。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Rich%20abstract%20theatre%20stage%20with%20deep%20red%20curtains%20and%20warm%20spotlight%2C%20elegant%20classical%20yet%20modern%20atmosphere%2C%20cinematic%20depth%2C%20clean%20dark%20background%20with%20negative%20space&width=800&height=500&seq=news-theater-10&orientation=landscape',
    category: 'film',
    categoryName: '影视新闻',
    tags: ['舞台剧', '改编', '电影'],
    author: '影视观察',
    source: '91.con 影视组',
    date: '2026-10-05',
    views: 24310,
  },
  {
    id: 'n-1011',
    title: '明星公益行动引发关注，用影响力传递温暖',
    summary: '多位艺人近期参与了公益项目，通过自身影响力呼吁公众关注相关社会议题。',
    content: [
      '多位艺人近期参与了不同领域的公益项目，从环保、教育到乡村发展，用实际行动传递温暖。',
      '参与活动的艺人表示，希望借助自身的影响力，让更多人关注到这些长期存在的议题。',
      '相关机构负责人也提到，持续的关注比一次性的热度更重要，公益需要的是长期的参与。',
      '活动后续还将通过纪录片的形式，记录项目推进的过程。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Warm%20hopeful%20abstract%20visual%20with%20soft%20sunlight%20and%20gentle%20orange%20gradients%2C%20hands%20reaching%20up%20silhouette%2C%20uplifting%20emotional%20atmosphere%2C%20clean%20minimal%20editorial%20style&width=800&height=500&seq=news-charity-11&orientation=landscape',
    category: 'star',
    categoryName: '明星动态',
    tags: ['公益', '明星', '正能量'],
    author: '娱乐编辑部',
    source: '91.con 娱乐组',
    date: '2026-10-04',
    views: 36120,
  },
  {
    id: 'n-1012',
    title: '纪录片新作聚焦小城生活，真实质感打动观众',
    summary: '一部聚焦小城日常的纪录片上线后口碑走高，导演用克制的镜头记录了普通人的生活切片。',
    content: [
      '一部聚焦小城生活的纪录片上线后获得了不错的口碑，观众被片中真实而克制的记录方式所打动。',
      '导演表示，团队在小城驻留了数月，尽量以不打扰的方式参与和观察，让镜头自然发生。',
      '不少观众在评论中提到，片中的许多瞬间让自己想起了家乡与家人，产生了强烈的情感共鸣。',
      '该片后续还计划推出延伸内容，记录更多普通人的故事。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20abstract%20small-town%20evening%20scene%2C%20soft%20orange%20sunset%20light%20over%20low%20buildings%2C%20gentle%20documentary%20mood%2C%20cinematic%20and%20clean%20with%20negative%20space&width=800&height=500&seq=news-doc-12&orientation=landscape',
    category: 'film',
    categoryName: '影视新闻',
    tags: ['纪录片', '真实', '口碑'],
    author: '影视观察',
    source: '91.con 影视组',
    date: '2026-10-03',
    views: 21890,
  },
  {
    id: 'n-1013',
    title: '音乐节圆满落幕，多元风格同台碰撞',
    summary: '为期三天的音乐节顺利收官，多组乐队与歌手轮番登台，多元风格的同台碰撞成为最大亮点。',
    content: [
      '为期三天的音乐节顺利落幕，来自不同风格的乐队与歌手轮番登台，为现场观众带来了丰富的听觉体验。',
      '主办方表示，今年的阵容在风格上做了更丰富的搭配，希望让不同偏好的观众都能找到共鸣。',
      '不少观众表示，现场的氛围和线上观看完全不同，这种共同的体验是音乐节最珍贵的部分。',
      '主办方透露，明年会继续优化场地与服务，提升整体体验。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Energetic%20abstract%20music%20festival%20scene%20with%20warm%20orange%20stage%20beams%20and%20crowd%20silhouettes%2C%20night%20sky%2C%20vibrant%20red%20and%20amber%20lighting%2C%20cinematic%20wide%20composition&width=800&height=500&seq=news-festival-13&orientation=landscape',
    category: 'music',
    categoryName: '音乐资讯',
    tags: ['音乐节', '现场', '乐队'],
    author: '音乐前线',
    source: '91.con 音乐组',
    date: '2026-10-02',
    views: 47215,
  },
  {
    id: 'n-1014',
    title: '经典 IP 宣布重制，情怀与创新如何平衡',
    summary: '一部承载许多观众回忆的经典 IP 宣布重制，制作方表示会在尊重原作的基础上加入新的表达。',
    content: [
      '一部拥有广泛观众基础的经典 IP 宣布启动重制计划，消息公布后迅速引发讨论。',
      '制作方表示，团队会尽量保留原作中最受观众喜爱的部分，同时用当下的技术与叙事方式重新呈现。',
      '不少观众在期待的同时也表达了担心，希望重制不要破坏记忆中的经典。',
      '制作方回应称，会认真听取观众的反馈，让重制既保留情怀，也具备新的生命力。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Nostalgic%20abstract%20retro%20cinema%20visual%20with%20film%20strip%20and%20warm%20amber%20glow%2C%20vintage%20yet%20modern%20aesthetic%2C%20red%20accents%2C%20clean%20dark%20background%20with%20negative%20space&width=800&height=500&seq=news-ip-14&orientation=landscape',
    category: 'film',
    categoryName: '影视新闻',
    tags: ['经典IP', '重制', '情怀'],
    author: '娱乐编辑部',
    source: '91.con 影视组',
    date: '2026-10-01',
    views: 52980,
    hot: true,
  },
  {
    id: 'n-1015',
    title: '新锐导演处女作入围国际影展，华语新力量受关注',
    summary: '一位新锐导演的处女作入围国际影展竞赛单元，其独特的影像风格获得选片人关注。',
    content: [
      '一位新锐导演的长片处女作入围国际影展竞赛单元，成为本届入围名单中备受关注的华语作品之一。',
      '影片以细腻的影像语言讲述了一段关于成长与告别的故事，选片人评价其“在克制中蕴含力量”。',
      '导演表示，作品源于自己的一段真实感受，希望通过影像让更多人看到相似的情绪。',
      '影片后续将在多个影展进行展映，具体的国内上映计划也在推进中。',
    ],
    cover: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20film%20festival%20visual%20with%20warm%20amber%20and%20deep%20red%20gradients%2C%20elegant%20spotlight%20and%20grained%20texture%2C%20refined%20cinematic%20atmosphere%2C%20clean%20composition&width=800&height=500&seq=news-debut-15&orientation=landscape',
    category: 'film',
    categoryName: '影视新闻',
    tags: ['影展', '新锐导演', '处女作'],
    author: '影视观察',
    source: '91.con 影视组',
    date: '2026-09-30',
    views: 19860,
  },
];